import gql from "graphql-tag"


const GET_ADDRESS_MODIFICATION = gql`
  fragment OrderAddressesModificationAddressFields on OrderAddressesModificationUpdateDataAddress {
    givenName
    familyName
    streetAddress
    streetAddress2
    postalCode
    city
    stateOrProvince
    country
    telephoneNumber
    email
    pcc
  }
  query orderModificationAddresses($modificationId: ID!) {
    Order {
      orderModificationAddresses(modificationId: $modificationId) {
        id
        addresses {
          data {
            shippingAddress {
              ...OrderAddressesModificationAddressFields
            }
            billingAddress {
              ...OrderAddressesModificationAddressFields
            }
          }
        }
        orderId
        started
        completed
        failed
        created
        updated
        restarts
        restarted
        revision
        type
        giftCardProvider {
          providerName
          providerId
          status {
            current
          }
        }
        paymentProvider {
          providerName
          providerId
          status {
            current
          }
        }
        bonusProvider {
          providerName
          providerId
          status {
            current
          }
        }
        promotionProvider {
          providerName
          providerId
        }
        shippingProvider {
          providerName
          providerId
          status {
            current
          }
        }
        voucherProvider {
          providerId
          providerName
        }
        reason {
          code
          cause
        }
        orderReference
      }
    }
  }
`

export default GET_ADDRESS_MODIFICATION
